<!-- Footer -->
<section class="flex flex-auto justify-center w-full bg-white ">
    <footer class=" dark:dark:bg-slate-800 w-full max-w-360 sm:mb-0  md:pb-3 overflow-hidden">
        <!-- <div class="w-[90%] mx-auto mt-5">
            <fuse-card
                class="relative overflow-hidden px-6 py-24  sm:px-24 xl:py-32 bg-[url('https://images.pexels.com/photos/533923/pexels-photo-533923.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1')] bg-cover bg-no-repeat bg-center">
                <div class="absolute flex flex-col inset-0 bg-gradient-to-r from-gray-800 via-gray-800/40 "></div>
                <div class="flex flex-col justify-end">
                    <h2
                        class="mx-auto max-w-2xl text-center text-3xl font-bold tracking-tight text-white sm:text-4xl z-10 font-primary">
                        Never miss an offer</h2>
                    <p class="mx-auto mt-2 max-w-xl text-center text-lg leading-8 text-white z-10">Subscribe and be the
                        first to receive our exclusive offers.</p>
                    <form class="flex flex-col sm:flex-row mx-auto mt-10 max-w-md gap-x-4 z-10">
                        <label for="email-address" class="sr-only">Email address</label>
                        <input id="email-address" name="email" type="email" autocomplete="email" required=""
                            class="min-w-0 flex-auto bg-white rounded-md border-0 px-3.5 py-2 text-black shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
                            placeholder="Enter your email">
                        <button type="submit"
                            class="flex-none w-30 rounded-md bg-primary-100 mt-5 sm:mt-0 px-3.5 py-2.5 text-sm font-semibold text-primary-600 shadow-sm hover:bg-primary-600 hover:text-primary-100 transition transition-duration: 500ms focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">Notify
                            me</button>
                    </form>
                </div>
            </fuse-card>
        </div> -->
        @if(view.site && view.destinations) {
        <div class="dark:dark:bg-slate-800 mt-10">
            <div
                class="max-w-screen-lg text-gray-800 grid grid-cols-1 md:grid-cols-3 mx-auto">
                <div class="justify-center items-center p-5">
                    @if(view.site.id == 70) {
                    <a href="{{view.site?.website}}" class="flex justify-start mb-6 font-primary dark:text-white">
                        @if(view.site?.logoUrl2) {
                        <img [alt]="view.site?.name" [src]="view.site?.logoUrl2" style="max-width: 65%;">
                        }
                    </a>
                    }
                    @if(view.site?.id == 63) {
                    <a href="{{view.site?.website}}" class="flex justify-start mb-6 font-primary dark:text-white">
                        @if(view.site?.logoUrl2) {
                            <div class="flex flex-col items-center">
                                <img [alt]="view.site?.name" [src]="view.site?.logoUrl2" style="max-width: 90%;">
                                <div class="flex flex-col items-center">
                                    <span class="text-gray-500 text-xl lg:text-2xl py-3 text-center font-primary dark:text-white">{{view.site?.slogan}}</span>
                                    <img class="mx-auto max-w-48" src="assets/xltravel/members/XL MEMBER LOGOS-21.png?v=2" alt="Logo image">
                                </div>
                            </div>
                        }
                    </a>
                    }
                    @if(view.site?.id != 63 && view.site.id != 70) {
                    <a href="{{view.site?.website}}" class="flex justify-start mb-6 font-primary dark:text-white">
                        @if(view.site?.logoUrl) {
                        <img [alt]="view.site?.name" [src]="view.site?.logoUrl" style="max-width: 90%;">
                        }
                    </a>
                    }
                </div>
                <!-- <div class="p-5 justify-center">
                    <div class="flex flex-col">
                        <h1
                            class="text-3xl font-semibold font-primary tracking-wide mb-2 dark:text-white">
                            Quick Links</h1>
                        @if (view.site?.profile.heading.border==1) {
                        <div class="flex items-baseline just justify-start">
                            <span class="w-10 border-b-2 border-primary-500"></span>
                            <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                        </div>
                        }

                    </div>
                    @if(view.pages) {
                    @for(page of view.pages; track page) {
                    <ul class="mt-3">
                        <li
                            class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500 dark:text-white">
                            <a [routerLink]="['/', page.seo.alias]"
                                class="cursor-pointer">{{page.name}}</a>
                        </li>
                    </ul>
                    }
                    }

                </div> -->
                <div class="p-5">
                    <div class="flex flex-col">
                        <h1 class="text-3xl font-semibold font-primary tracking-wide mb-2 dark:text-white">Destinations
                        </h1>
                        @if (view.site?.profile.heading.border==1) {
                        <div class="flex items-baseline justify-start">
                            <span class="w-10 border-b-2 border-primary-500"></span>
                            <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                        </div>
                        }
                    </div>
                    @if(view.destinations) {
                    @for(item of view.destinations; track item) {
                    <ul class="mt-3">
                        <li
                            class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500 dark:text-white">
                            <a class="cursor-pointer" [routerLink]="['/destination', item.id, item.seo.alias]">{{
                                item.name }}</a>
                        </li>
                    </ul>
                    }
                    }
                    <!-- <p class="neon-text text-black mt-3">PLUS countless other unforgettable locations</p> -->
                    <p class="mt-3 transform-none" aria-label="PLUS anywhere you can">
                        PLUS anywhere you can... <span class="typewriter"></span>
                    </p>
                </div>
                <div class="p-5">
                    <div class="flex flex-col">
                        <h1 class="text-3xl font-semibold font-primary tracking-wide mb-2 dark:text-white">Contact Us
                        </h1>
                        @if (view.site?.profile.heading.border==1) {
                        <div class="flex items-baseline justify-start">
                            <span class="w-10 border-b-2 border-primary-500"></span>
                            <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                        </div>
                        }
                    </div>
                    @if(view.site?.address) {
                    <ul class="mt-3">
                        <li class="mb-4 flex items-center group">
                            <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:location_on'"></mat-icon>
                            </div>
                            <div>
                                <p class="text-gray-600 dark:text-white">{{view.site.address}}</p>
                            </div>
                        </li>
                    </ul>
                    }
                    @if(view.site?.telephone) {
                    <ul class="mt-2">
                        <li class="mb-4 flex items-center group">
                            <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:local_phone'"></mat-icon>
                            </div>
                            <div>
                                <p class="text-gray-600 dark:text-white">{{view.site?.telephone}}</p>
                            </div>
                        </li>
                    </ul>
                    }
                    @if(view.site?.emailAddress) {
                    <ul class="mt-2">
                        <li class="mb-4 flex items-center group transform transition-transform duration-300 hover:translate-x-2">
                            <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:email'"></mat-icon>
                            </div>
                            <a [href]="'mailto:' + view.site?.emailAddress" class="text-gray-600 dark:text-white hover:text-primary-500">
                                {{view.site?.emailAddress}}
                            </a>
                        </li>
                    </ul>
                    }
                    @if(view.site?.website) {
                    <ul class="mt-2">
                        <li
                            class="mb-4 flex items-center group transform transition-transform duration-300 hover:translate-x-2">
                            <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white"
                                    [svgIcon]="'heroicons_mini:globe-europe-africa'"></mat-icon>
                            </div>
                            <div>
                                <a href="https://{{view.site?.website}}" target="_blank"
                                    class="text-gray-600 hover:text-primary-500 dark:text-white">{{view.site?.website}}</a>
                            </div>
                        </li>
                    </ul>
                    }
                </div>
            </div>
        </div>
        }
        @if(view.site && view.destinations) {
        <div class="">
            <div
                class="flex px-3 m-auto border-t text-gray-800 text-sm flex-col items-center">
                <div class="flex items-center py-4">
                    @if(view.site?.socialUrlFacebook) {
                    <div class="w-6 mx-5">
                        <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                            class="group relative w-10 h-10 mr-5 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-5 text-white group-hover:text-primary"
                                [svgIcon]="'feather:facebook'"></mat-icon>
                        </a>
                    </div>
                    }
                    @if(view.site?.socialUrlInstagram) {
                    <div class="w-6 mx-5">
                        <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                            class="group relative w-10 h-10 mr-5 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-5 text-white group-hover:text-primary"
                                [svgIcon]="'feather:instagram'"></mat-icon>
                        </a>
                    </div>
                    }
                    @if(view.site?.socialUrlLinkedIn) {
                    <div class="w-6 mx-5">
                        <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                            class="group relative w-10 h-10 mr-5 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-5 text-white group-hover:text-primary"
                                [svgIcon]="'feather:linkedin'"></mat-icon>
                        </a>
                    </div>
                    }
                </div>
                <div class="w-full py-7 border-t">
                    <div class="flex items-center justify-center flex-col lg:justify-between lg:flex-row px-15">
                        <p class="text-sm text-center text-gray-500 dark:text-white">© Copyright &copy; {{currentYear}} <span class="mx-1 text-primary-500">TravelFind.Me</span>(Pty) Ltd. All rights reserved.</p>
                        
                        @if(view.pages) {
                            <ul class="flex flex-col md:flex-row items-center gap-9 mt-4 lg:mt-0">
                            @for(page of view.pages; track page) {
                            <li><a [routerLink]="['/policy', (page.name.toLowerCase().includes('privacy') && !page.seo.alias.toLowerCase().includes('privacy')) ? 'privacy-policy' : (page.name.toLowerCase().includes('terms') && !page.seo.alias.toLowerCase().includes('terms')) ? 'terms-conditions' : page.seo.alias]" class="text-sm text-gray-500 dark:text-white hover:text-primary-500">{{page.name}}</a></li>
                            }
                            @if(view.site?.id === 75) {
                                <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/XL-HIGHWAY-BOOKING-FORM.pdf'"
                                        target="_blank"
                                        class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Download Booking Form</a></li>
                                <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/XL-HIGHWAY-TERMS-AN-CONDITIONS.pdf'"
                                        target="_blank"
                                        class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">T & C's</a></li>
                                }
                            @if(view.site?.id === 99) {
                                <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/sandown-booking-form.pdf'"
                                        target="_blank"
                                        class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Download Booking Form</a></li>
                                <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/sandown-terms-conditions.pdf'"
                                        target="_blank"
                                        class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Terms & Conditions</a></li>
                                }
                            </ul>
                        }
                    </div>
                </div>
            </div>
        </div>
        }
    </footer>
</section>